import React, { useState, useEffect } from 'react';
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaYoutube } from 'react-icons/fa';

const Footer = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = windowWidth <= 768;
  const isTablet = windowWidth > 768 && windowWidth <= 1024;

  const dynamicStyles = {
    container: {
      ...styles.container,
      flexDirection: isMobile ? 'column' : 'row',
      textAlign: isMobile ? 'center' : 'left',
      gap: isMobile ? '20px' : '10px',
    },
    left: {
      ...styles.left,
      justifyContent: isMobile ? 'center' : 'flex-start',
      fontSize: isMobile || isTablet ? '15px' : '17px',
    },
    center: {
      ...styles.center,
      fontSize: isMobile ? '22px' : isTablet ? '25px' : '27px',
    },
    right: {
      ...styles.right,
      fontSize: isMobile || isTablet ? '14px' : '17px',
      textAlign: isMobile ? 'center' : 'right',
      width: isMobile ? '100%' : 'auto',
    },
  };

  return (
    <footer style={styles.footer}>
      <div style={dynamicStyles.container}>
        <div style={dynamicStyles.left}>
          <a href="/privacy-policy" style={styles.link}>Privacy Policy</a>
          <span style={styles.divider}>|</span>
          <a href="/terms-conditions" style={styles.link}>Terms of Services</a>
        </div>

        <div style={dynamicStyles.center}>
          <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" style={styles.icon}><FaFacebookF /></a>
          <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" style={styles.icon}><FaInstagram /></a>
          <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" style={styles.icon}><FaLinkedinIn /></a>
          <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" style={styles.icon}><FaYoutube /></a>
        </div>

        <div style={dynamicStyles.right}>
          <p style={styles.copyText}>Copyright© 1999 - 2025 Om Sai Credit. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};

const styles = {
  footer: {
    background: 'linear-gradient(180deg, #000b3e 0, #020202 59%)',
    padding: '80px 20px',
    fontFamily: 'Outfit, sans-serif',
    color: '#ccc',
  },
  container: {
    maxWidth: '1200px',
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  left: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    flexWrap: 'wrap',
  },
  center: {
    display: 'flex',
    gap: '20px',
    justifyContent: 'center',
  },
  right: {
    color: '#999',
  },
  icon: {
    color: '#ccc',
    transition: '0.3s',
    textDecoration: 'none',
  },
  link: {
    color: '#bbb',
    textDecoration: 'none',
    fontWeight: '500',
  },
  divider: {
    color: '#666',
  },
  copyText: {
    margin: 0,
  },
};

export default Footer;
